import React from "react";
import { Container, Typography, Box, Divider, Paper } from "@mui/material";
import { LAYOUT_HEIGHT } from 'state/constants';
import PageHeader from "components/PageHeader";


const About = () => {
    return (
        <Box>
            <PageHeader/>
            
            <Container 
                maxWidth="md" 
                sx={{ 
                    minHeight: LAYOUT_HEIGHT,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mt: 6, 
                    mb: 6, 
                }}
            >
                <Paper 
                    elevation={3} 
                    sx={{ 
                        p: 4, 
                        borderRadius: 4, 
                        width: "100%",
                        maxWidth: "540px", 
                        backgroundColor: 'background.paper' 
                    }}
                >
                    <Typography variant="h4" color="primary.main" align="center" gutterBottom>
                        About Us
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h5" color="primary.main" gutterBottom>
                            Our Mission
                        </Typography>
                        <Box sx={{ textAlign: "justify", mx: "auto" }}>
                            <Typography variant="body1">
                                We are committed to delivering reliable, high-performance solutions that uphold the highest standards of integrity and professionalism. Our mission is to empower people through technology rooted in traditional values: quality, discipline, and responsibility.
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h5" color="primary.main" gutterBottom>
                            What We Do
                        </Typography>                        
                        <Box sx={{ textAlign: "justify", mx: "auto" }}>
                            <Typography variant="body1">
                                Our team specializes in designing and building scalable systems that solve real world problems - particularly in aviation. We believe in getting things right the first time, using clean code and rock-solid processes.
                            </Typography>
                        </Box>
                    </Box>

                    <Box>
                        <Typography variant="h5" color="primary.main" gutterBottom>
                            Our Values
                        </Typography>                        
                        <Box sx={{ textAlign: "justify", mx: "auto" }}>
                            <Typography variant="body1">
                                We operate with respect, clarity, and long-term thinking. We believe in mastering fundamentals, not chasing trends. Simplicity, security, and accountability are at the heart of everything we build.
                            </Typography>
                        </Box>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default About;
